<template>
  <div>
    <a href="#/" @click="showModal()">Payout Confirmation</a>

    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title>Payout Confirmation</template>

      <div class="row">
        <div class="col text-center">
          <label class="form-label pt-0 mb-0" for="dealer-name">Have you paid {{`${user.name} ${user.surname}`}} <b>{{formattedPrice(user.balance)}}</b></label>
        </div>
      </div>

      <div class="row">
        <div class="col text-center">
            <label class="form-label pt-2 mb-2">Transaction Reference</label>
            <input class="form-control2" style="text-align:center;" v-model="reference">
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
        <button type="button" class="btn btn-danger submit col" @click="hideModal">No</button>
        </div>
        <div class="col">
          <button v-if="updating" type="button" class="btn btn-success submit col">
          <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
          <button v-else type="button" class="btn btn-success submit col" @click="sendConfirmation">Yes</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['user'],

  data() {
    return {
      updating: false,
      reference: null,
    };
  },

  methods: {

    showModal() {
      this.$bvModal.show("bv-modal-example");
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

    sendConfirmation() {

      if (!this.reference) { this.sweetfire('Please enter a transaction reference.'); }
      else {

          this.updating = true;

          axios.post('/profile/payout-confirmation', {
            user_id: this.user.id,
            reference: this.reference,
            })
            .then((response) => {

              if (response.data.success) {
                this.hideModal();
                this.successAlert(response.data.message);
                this.$emit('update-balance', response.data.balance);
              } else {
                this.sweetfire(response.data.message);
              }

              this.updating = false;
              
            });

        }

      },

      successAlert(text) {
        Swal.fire({
        title: text,
        customClass: { title: "popup-title", icon: 'custom-icon-size' },
        icon: 'success',
        showConfirmButton: false,
        timer: 3000,
        });
      },

      sweetfire(text) {
        Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: { title: "popup-title" },
        })
      },

  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}
label.form-label {
  font-weight: 600 !important;
}

.input-group-text.price {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 1.0rem;
}

input.form-control.price {
    padding-left: 0rem;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }


</style>